import React from 'react';

import { LottieSvg } from 'lottie-react';

import styles from './AnimatedIconFail.module.css';
import failedAnimation from '@/static/lottie/failed.json';

export const AnimatedIconFail: React.FC = () => (
    <div className={styles.animatedIconFail} data-testid="animated-icon-fail-div">
        <LottieSvg src={failedAnimation} loop={false} autoplay />
    </div>
);
